module.exports = __webpack_public_path__ + "static/media/lethaScreenshot.4c148f0f.jpg";